export default {
    title: {
        default: 'Card Privileges'
    }
}
